import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const ParcelNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      type="text"
      id="parcelNumber"
      name="parcelNumber"
      label="Parcel Number"
      placeholder="Enter parcel number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default ParcelNumber;
